import React from 'react';
import { Box } from '@mui/material';

const LOGO_SRC =
  'https://ae-cp-static-files.s3.eu-central-1.amazonaws.com/client-dashboard/rocky-logo-vertical.png';
const WORDMARK_ASPECT_RATIO = '180 / 88';

export const BrandLogo: React.FC<{ width?: number }> = ({ width = 134 }) => {
  return (
    <Box
      component="img"
      src={LOGO_SRC}
      alt="AgileEngine"
      sx={{
        width: `${width}px`,
      }}
    />
  );
};

export const BrandWordmark: React.FC<{ height: number }> = ({ height }) => (
  <Box
    component="img"
    src={LOGO_SRC}
    alt="AgileEngine"
    sx={{
      height,
      aspectRatio: WORDMARK_ASPECT_RATIO,
      objectFit: 'cover',
      objectPosition: 'right',
    }}
  />
);
